import {
  OfferStatus,
  OfferPricingType,
  PercentageType,
  OfferType,
} from 'src/common/apollo/types/swarmx/graphql'
import { Offer } from 'src/common/types/models/Offer'
import { BadgeType } from 'src/common/ui-kit/Badge'
// import { Theme } from 'src/theme'
import dayjs from 'dayjs'
import { OffersManagementTab } from '../types'

export type OfferBadge = {
  label: string
  // color: keyof Theme['colors']
  color: string
  type?: BadgeType
  tabs?: OffersManagementTab[] // undefined - to show for all tabs
}

export const getMarketPriceBadgeForOffer = (
  offer: Offer
): OfferBadge | undefined => {
  const { offerPrice } = offer
  if (
    offerPrice.pricingType === OfferPricingType.DynamicPricing &&
    offerPrice.percentage
  ) {
    const percentageType =
      offerPrice.percentageType === PercentageType.Minus ? '-' : '+'

    return {
      label: `Market ${percentageType}${offerPrice.percentage}%`,
      color: 'success',
      type: 'status',
      tabs: ['my'],
    }
  }
}

export const getIsShowBadgeByTab = (
  activeTab: OffersManagementTab,
  badge?: OfferBadge
) => (badge?.tabs ? badge.tabs.includes(activeTab) : true)

export const getBadgesForOffer = (
  offer: Offer,
  activeTab: OffersManagementTab
): OfferBadge[] => {
  const badgesArray: OfferBadge[] = []

  const expired = dayjs.unix(offer.expiryTimestamp).isBefore(dayjs())
  if (expired && offer.offerStatus !== OfferStatus.Cancelled && offer.offerStatus !== OfferStatus.FullyTaken) {
    badgesArray.push({
      label: 'Expired',
      color: 'warn',
      type: 'status',
    })
  }

  if (offer.isPrivate) {
    badgesArray.push({
      label: 'Private',
      color: 'info',
      type: 'status',
    })
  }

  if (offer.offerType === OfferType.BlockOffer) {
    badgesArray.push({
      label: 'Block offer',
      color: 'info',
      type: 'status',
    })
  } else {
    badgesArray.push({
      label: 'Partial offer',
      color: 'info',
      type: 'status',
      tabs: ['my'],
    })
  }

  const { offerPrice } = offer
  if (offerPrice.pricingType === OfferPricingType.DynamicPricing) {
    badgesArray.push({
      label: `Dynamic price`,
      color: 'success',
      type: 'status',
      tabs: ['my'],
    })
  } else {
    badgesArray.push({
      label: 'Fixed price',
      color: 'success',
      type: 'status',
    })
  }

  if (offer.offerStatus === OfferStatus.Cancelled) {
    badgesArray.push({
      label: 'Cancelled',
      color: 'error',
      type: 'status',
    })
  }

  if (offer.offerStatus === OfferStatus.FullyTaken) {
    badgesArray.push({
      label: 'Completed',
      color: 'success',
      type: 'status',
    })
  }

  if (offer.offerStatus === OfferStatus.PartiallyTaken) {
    badgesArray.push({
      label: 'Partially Filled',
      color: 'warn',
      type: 'status',
    })
  }

  if (offer.offerStatus === OfferStatus.NotTaken) {
    badgesArray.push({
      label: 'Not filled',
      color: 'secondary',
    })
  }

  const filteredBadgesArray = badgesArray.filter(badge =>
    getIsShowBadgeByTab(activeTab, badge)
  )

  return filteredBadgesArray
}
